import * as React from 'react'
import styled from 'styled-components'
import { CenteringContainer, StyledH2 } from '@src/styles'

const RetryButton = styled.button`
  margin-top: 16px;
  padding: 12px 24px;
  background-color: ${props => props.theme.accent};
  color: ${props => props.theme.white};
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    opacity: 0.9;
  }
`

interface ChunkErrorBoundaryState {
  hasError: boolean
}

export class ChunkErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ChunkErrorBoundaryState
> {
  state: ChunkErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): ChunkErrorBoundaryState {
    return { hasError: true }
  }

  retry = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <CenteringContainer>
          <StyledH2>Failed to load this page</StyledH2>
          <p>This may be a network issue. Please check your connection and try again.</p>
          <RetryButton onClick={this.retry}>Retry</RetryButton>
        </CenteringContainer>
      )
    }
    return this.props.children
  }
}
